import { css } from "@emotion/react";

import {
    TOOLTIP_PLACEMENT,
    TooltipGeneral
} from "components/DesignComponents/Tooltips";
import { useOverflow } from "shared";

import { RoleNameProps } from "./types";

const RoleName = ({ name }: RoleNameProps) => {
    const { ref, isOverflowing } = useOverflow([name]);

    return (
        <TooltipGeneral
            title={name}
            disableHoverListener={!isOverflowing}
            placement={TOOLTIP_PLACEMENT.Top}
            removeArrow
        >
            <div
                ref={ref}
                css={css({
                    overflowX: "hidden",
                    textOverflow: "ellipsis"
                })}
            >
                {name}
            </div>
        </TooltipGeneral>
    );
};

export default RoleName;
